import React, { Component } from "react";
import Select from "react-select";
import get_options from "get_options";
import styles from './Player.module.css';

const options = get_options();

class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_song: options[0]
    };
    this.handle_song_change = this.handle_song_change.bind(this);
  }

  handle_song_change(new_song, action) {
    console.log(new_song);
    console.log(action);
    this.setState({ current_song: new_song });
    var player = document.getElementById('timestretch_player');
    var parent = player.parentNode;
    player.remove();
    player.src = `https://29a.ch/timestretch/#a=${this.state.current_song.value}&p=1&d=0`;
    parent.appendChild(player);
  }

  render() {
    return (
      <>
        <Select
          options={options}
          placeholder="Auswählen ..."
          onChange={this.handle_song_change}
          value={this.state.current_song}
        >
          Hello World!
        </Select>
        <div class={styles.timestretch_player_container}>
        <iframe
          src={`https://29a.ch/timestretch/#a=${this.state.current_song.value}&d=0`}
          title="timestretch_player"
          id="timestretch_player"
          class={styles.timestretch_player}
        />
        </div>
      </>
    );
  }
}

export default Player;
